module.exports = __webpack_public_path__ + "lp/img/chat_icon_sp_off@2x.a73ba072.png";